import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=57acf15f&lang=pug"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports